import classNames from "classnames";
import { getConfiguredGlassPrice } from "app/providers/configuredOptionPricing";
import { elementSize } from "features/option-controls/color-option-controls/DoorColorChoice";
import { useSearchParams } from "react-router-dom";
import { OptionTemplate } from "shared/api/middleware-api-client";
import Icon, { IconTypes } from "shared/ui/icon";
import OptionConfigurationImage from "shared/ui/option-configuration-image";
import Text from "shared/ui/typography/Text";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";

interface GlassCardProps {
  glass: OptionTemplate;
  selectedDoor: OptionTemplate;
  updateGlass: (glass: OptionTemplate) => void;
}

export const GlassCard = ({
  glass,
  selectedDoor,
  updateGlass,
}: GlassCardProps) => {
  const [searchParams] = useSearchParams();
  const fullGlassPrice = getFormattedPrice(
    getConfiguredGlassPrice(selectedDoor, glass),
  );

  const isGlassSelected =
    glass.code === searchParams.get("glass") ||
    (glass.default &&
      (searchParams.get("glass") === null || searchParams.get("glass") === ""));

  return (
    <button
      aria-pressed={isGlassSelected}
      className="gg-relative gg-flex gg-h-full gg-w-fit gg-max-w-min gg-flex-col gg-text-left"
      data-testid={`door-glass-${glass.code}`}
      onClick={() => updateGlass(glass)}
    >
      {isGlassSelected ? (
        <Icon
          name={IconTypes.WHITE_CHECK}
          alt=""
          className={
            "gg-absolute -gg-top-2.5 gg-left-full gg-z-10 gg-aspect-square gg-w-5 -gg-translate-x-2.5 gg-rounded-full gg-bg-green-500 gg-p-1.5"
          }
        />
      ) : null}

      <div className={elementSize}>
        <OptionConfigurationImage
          imageId={glass.imageId}
          alt={glass.name}
          className={classNames(
            "gg-mb-1.5 gg-h-full gg-w-full gg-rounded gg-border gg-transition gg-duration-300 gg-ease-in-out hover:gg-scale-[1.015] hover:gg-border-[#9493A3]",
            {
              "gg-border-[#9493A3]": isGlassSelected,
              "gg-border-[#EAE9ED]": !isGlassSelected,
            },
          )}
        />
      </div>

      <Text className="gg-mb-1 gg-text-xs gg-font-bold">{glass.name}</Text>

      <Text className="gg-text-xs gg-text-secondary-text">
        {fullGlassPrice}
      </Text>
    </button>
  );
};
